import React from "react";

import { formatAmount } from "../../../helpers/format";
import Link from "../../../components/Link";
import Text from "../../../components/Text";
import Title from "../../../components/Title";
import Background from "../../../components/Background";

import style from "./style.module.css";

export default function Product({ item = {}, size }) {
    const {
        image,
        purchase_link = "",
        name = "",
        desc = "",
        price = "",
    } = item

    return (
        <Link to={purchase_link} className={`${style.products} ${style[size]}`}>
            <div className={style.merchandiseCardInner}>
                <div className={style.merchandiseImage}>
                    <Background className={style.merchandiseCardImage} size="664x664" src={image} cPosition="topLeft" />
                </div>
                <div className={style.merchandiseTextContent}>
                    {
                        name !== "" && (
                            <Title transform="uppercase" className="fontTeko" tag="h4">{name}</Title>
                        )
                    }
                    {
                        desc !== "" && (
                            <div className={style.desc}>
                                <Text className="size16" text={desc} />
                            </div>
                        )
                    }
                    {
                        price !== "" && (
                            <div className={style.productAmount}>
                                <Text text={formatAmount(price, "£")} />
                            </div>
                        )
                    }
                </div>
            </div>
        </Link>
    )
}